<i18n lang="yaml">
en:
  read: 'Read the full story'
ru:
  read: 'Читать историю'
</i18n>

<template>
  <swiper-slide class="story">
    <img
      v-if="item.logoSrc"
      :data-src="item.logoSrc"
      alt=""
      class="story__logo swiper-lazy"
    >
    <p
      class="story__description"
      v-html="item.description"
    ></p>

    <nuxt-link
      class="story__button"
      :to="item.link"
    >
      <span
        class="btn btn--outline btn--sm"
        @click="slideClick"
        @mousedown="slideClick"
        v-html="$t('read')"
      ></span>
    </nuxt-link>
  </swiper-slide>
</template>

<script>
import {SwiperSlide} from 'vue-awesome-swiper'

export default {
  name: 'StoriesItem',
  components: {
    SwiperSlide
  },
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    slideClick() {
      const link = this.item.link.split('/').filter(Boolean)
      this.$emit('slideClick', 'click', link[link.length - 1])
    }
  }
}
</script>

<style lang="scss">
.card-slider {
  .story {
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    box-shadow: 0 0 2px rgba(0, 0, 0, 0.12), 0 4px 16px rgba(0, 0, 0, 0.08);
    border-radius: 12px;

    @media (max-width: $breakpoint-md) {
      padding: 16px;
    }
  }

  .story__logo {
    margin-bottom: 16px;
    max-height: 64px;
  }

  .story__description {
    margin-bottom: 24px;
  }

  .story__button {
    margin-top: auto;
  }
}
</style>